
import { useSelector } from 'react-redux';
import { RootState } from '../../Store';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './landingpage.module.scss';
import LandingPageAdmin from './LandingPageAdmin';
import LandingPageAnonymous from './LandingPageAnonymous';
import LandingPageAuftraggeber from './LandingPageAuftraggeber';
import LandingPageAussendienst from './LandingPageAussendienst';
import LandingPageFaktura from './LandingPageFaktura';
import LandingPageManager from './LandingPageManager';
import LandingPageOffice from './LandingPageOffice';

export default function LandingPage() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    return (
        <div className={styles.landingpageContainer}>

            {auth.isAuthCheckFinished === false &&
                <><div>Lädt...</div></>
            }

            <LandingpageHeader />

            {auth.isAuthCheckFinished && auth.isAuthenticated === false &&
                <LandingPageAnonymous />
            }

            {auth.isAuthCheckFinished && auth.isAuthenticated === true &&
                <>
                    {auth.user?.rollen.includes("admin") && <LandingPageAdmin />}
                    {auth.user?.rollen.includes("office") && <LandingPageOffice />}
                    {auth.user?.rollen.includes("auftraggeber") && <LandingPageAuftraggeber />}
                    {auth.user?.rollen.includes("manager") && <LandingPageManager />}
                    {auth.user?.rollen.includes("faktura") && <LandingPageFaktura />}
                    {auth.user?.rollen.includes("aussendienst") && <LandingPageAussendienst />}
                    <Footer />
                </>}

        </div>
    );
}
